import "./App.css";

import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import Home from "./components/Home_Screen/Home";
import PreArrivalCheckIn from "./components/CheckIn/PreArrivalCheckin/CheckIn";
import { CheckInAddOn } from "./components/CheckIn/Addon/CheckInAddon";
import RatingDisplay from "./components/Rating/Rating";
import ServiceContainer from "./components/Services/Service";
import Registration from "./components/Registration/Registration";
import HouseKeepingService from "./components/Services/HouseKeepingService";
import TermsAndConditions from "./components/Footer/TermsAndConditions";
import PrivacyPolicy from "./components/Footer/PrivacyPolicy";
import UpgradeRoom from "./components/UpgradeRoom/UpgradeRoom";
import PreArrivalCheckInTwilio from "./components/CheckIn/PreArrivalLoginForTwilio/PreArrivalCheckInTwilio";
import IdProofUpload from "./components/CheckIn/PreArrivalCheckin/IdProofUpload";
import RoomService from "./components/RoomService/RoomService";
import HouseKeeping from "./components/RoomService/HouseKeeping";
import AddOns from "./components/RoomService/AddOns";
import PropertyModal from "./components/Modal/propertyModal";
import GuestList from "./components/GuestList";
import { useEffect } from "react";

function App() {

  useEffect(() => {
    return () => {
      localStorage.removeItem('multiGuestSessionId');
    }
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="/:id" element={<Home />} />
        <Route path="/list/:id" element={<GuestList />} />
        <Route path="/rating/:propertyId" element={<PropertyModal />} />
        <Route path="/service/:id" element={<ServiceContainer />} />
        <Route path="/:id/houseKeeping" element={<HouseKeepingService />} />
        <Route path="/:id/check-in" element={<PreArrivalCheckIn />} />
        <Route path="/:id/addons" element={<CheckInAddOn />} />
        <Route path="/rating" element={<RatingDisplay />} />
        <Route path="/:propertyId/register" element={<Registration />} />
        <Route path="/terms" element={<TermsAndConditions />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/:id/upgrade-room" element={<UpgradeRoom />} />
        <Route path="/check-in" element={<PreArrivalCheckInTwilio />} />
        <Route path="/:id/id-proof" element={<IdProofUpload />} />
        <Route path="/:propertyId/roomService" element={<RoomService />} />
      </Routes>
    </Router>
  );
}

export default App;
